export default __webpack_public_path__ + "static/media/TheTradeDeskLogo.d696b9a9.png";